import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tierPriceHint", "quantity", "subtotal"]

  connect() {
    this.manualSubtotal = false
    this.currentHpp = Number(this.element.dataset.saleItemCurrentHppValue) || 0
    this.currentPriceTiers = this.parsePriceTiers(this.element.dataset.saleItemCurrentPriceTiersValue)
    this.syncHints()
  }

  updateProduct(event) {
    if (!this.hasTierPriceHintTarget && !this.hasSubtotalTarget) {
      return
    }

    const detail = event.detail || {}
    this.currentHpp = Number(detail.hpp) || 0
    this.currentPriceTiers = Array.isArray(detail.priceTiers) ? detail.priceTiers : []
    this.manualSubtotal = false

    this.syncHints()
    this.autofillSubtotal()
  }

  quantityChanged() {
    this.syncHints()
    this.autofillSubtotal()
  }

  subtotalChanged() {
    this.manualSubtotal = true
  }

  autofillSubtotal() {
    if (!this.hasSubtotalTarget || this.manualSubtotal) {
      return
    }

    const quantity = this.quantityValue()
    const unitPrice = this.currentUnitPrice(quantity)

    if (quantity <= 0 || unitPrice <= 0) {
      return
    }

    this.subtotalTarget.value = this.formatSubtotal(unitPrice * quantity)
  }

  quantityValue() {
    if (!this.hasQuantityTarget) {
      return 1
    }

    return Number(this.quantityTarget.value) || 0
  }

  syncHints() {
    const quantity = this.quantityValue()
    const unitPrice = this.currentUnitPrice(quantity)

    if (this.hasTierPriceHintTarget) {
      this.tierPriceHintTarget.textContent = unitPrice > 0 ? `Harga tier: ${this.formatPrice(unitPrice)}` : "Harga tier: -"
    }
  }

  currentUnitPrice(quantity) {
    const tiers = (this.currentPriceTiers || [])
      .map((tier) => ({
        min_quantity: Number(tier.min_quantity) || 0,
        unit_price: Number(tier.unit_price) || 0
      }))
      .filter((tier) => tier.min_quantity > 0)
      .sort((left, right) => left.min_quantity - right.min_quantity)

    const matchedTier = tiers.filter((tier) => quantity >= tier.min_quantity).pop()

    if (matchedTier) {
      return matchedTier.unit_price
    }

    return this.currentHpp || 0
  }

  parsePriceTiers(encodedValue) {
    if (!encodedValue) {
      return []
    }

    try {
      return JSON.parse(encodedValue)
    } catch (_error) {
      return []
    }
  }

  formatPrice(value) {
    const number = Number(value) || 0
    return new Intl.NumberFormat("id-ID").format(number)
  }

  formatSubtotal(value) {
    return Number(value).toFixed(2)
  }
}